var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormueLogoFullColors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 372 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314.986 34.4988L315.014 2.60718H305.105L305.078 34.4988C305.078 39.3947 303.122 44.09 299.642 47.552C296.161 51.0139 291.44 52.9588 286.518 52.9588C281.596 52.9588 276.875 51.0139 273.394 47.552C269.914 44.09 267.958 39.3947 267.958 34.4988H267.961V2.60718H258.054L258.052 34.4988C258.052 51.6508 272.422 62.9728 286.519 62.9788C300.358 62.9812 315.014 51.92 314.986 34.4988Z",
    fill: "#182361"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5404 1.02319C73.384 1.02319 67.3659 2.83897 62.247 6.24089C57.1282 9.64282 53.1385 14.4781 50.7825 20.1353C48.4266 25.7925 47.8101 32.0175 49.0112 38.0232C50.2123 44.0288 53.1769 49.5454 57.5301 53.8752C61.8833 58.2051 67.4297 61.1537 73.4678 62.3483C79.5059 63.5429 85.7646 62.9298 91.4524 60.5865C97.1401 58.2432 102.002 54.275 105.422 49.1837C108.842 44.0923 110.668 38.1065 110.668 31.9832C110.659 23.7749 107.376 15.9054 101.541 10.1012C95.7052 4.29707 87.7931 1.0323 79.5404 1.02319ZM100.759 31.9832C100.759 36.1572 99.5141 40.2374 97.1826 43.7079C94.8511 47.1785 91.5373 49.8834 87.6602 51.4808C83.7831 53.0781 79.5169 53.496 75.401 52.6817C71.2851 51.8674 67.5044 49.8574 64.537 46.906C61.5696 43.9545 59.5488 40.1942 58.7301 36.1004C57.9114 32.0066 58.3316 27.7633 59.9375 23.907C61.5434 20.0508 64.263 16.7548 67.7523 14.4359C71.2416 12.1169 75.3439 10.8792 79.5404 10.8792C85.1657 10.8855 90.5588 13.1109 94.5365 17.0671C98.5143 21.0234 100.752 26.3874 100.759 31.9824V31.9832Z",
    fill: "#182361"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.651 30.36C170.643 23.0021 167.701 15.9479 162.47 10.745C157.239 5.54219 150.147 2.61554 142.749 2.60718V12.4624C147.52 12.4675 152.094 14.3547 155.468 17.71C158.841 21.0654 160.739 25.6147 160.744 30.36H170.651Z",
    fill: "#182361"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.718 61.8217V51.966C165.947 51.9606 161.374 50.0733 158 46.7181C154.627 43.3629 152.729 38.8138 152.724 34.0688H142.813C142.821 41.4272 145.764 48.4817 150.995 53.6846C156.227 58.8876 163.32 61.8139 170.718 61.8217Z",
    fill: "#182361"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.133 34.0879H187.225V61.7387H197.133V34.0879Z",
    fill: "#182361"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.493 34.0879H232.584V61.7387H242.493V34.0879Z",
    fill: "#182361"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.745 2.60718H122.836V61.7388H132.745V2.60718Z",
    fill: "#182361"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55981 61.7388H12.7916V12.5356L43.286 12.4624V2.60718H2.55981V61.7388Z",
    fill: "#182361"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8207 27.29H22.2573V37.1452H33.8207V27.29Z",
    fill: "#182361"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M359.966 27.29H348.403V37.1452H359.966V27.29Z",
    fill: "#182361"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M214.794 38.8595L245.783 8.03789L238.777 1.06909L214.794 24.9219L190.813 1.06909L183.806 8.03789L214.794 38.8595Z",
    fill: "#182361"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M329.037 61.7388H369.44V51.8836L338.946 51.8104V12.5356L369.44 12.4624V2.60718H329.037V61.7388Z",
    fill: "#182361"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormueLogoFullColors);
export default __webpack_public_path__ + "static/media/formue-logo-full-colors.e1ae2bd35b959213c177034218a1323b.svg";
export { ForwardRef as ReactComponent };